<script>
    import Badge from '$lib/Badge.svelte';
    import arrow_right from '../arrow-right.svg';

    export let display = 'd-block';
</script>

<div id="try-pro" class="{display}">
    <h2 class="visually-hidden">Probeer 1848 Pro</h2>
    <Badge --margin={'0 0 13px 0'} bg_color={'white'} text={'PRO'}/>

    <p>Bespaar tijd en blijf nog beter op de hoogte met notificaties en eigen dossiers.</p>

    <a role="button" href="{''}" data-bs-toggle="modal" data-bs-target="#call-to-action"><b>Probeer nu gratis</b><img src={arrow_right} alt="" style="margin-left: 11px;" width="18.86" height="15.75"></a>
</div>

<style lang="scss">
    #try-pro {
        background-color: var(--gold-color);
        padding: 20px 30px;
        margin-bottom: var(--margin_bottom);

        p {
            font-size: 16px;
            line-height: 20.8px;
            font-weight: 400;
            margin-bottom: 12px;
        }
    }
</style>
